import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export default function ServiceCard({
  icon: Icon,
  title,
  text,
  number,
  tag,
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 25 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      whileHover={{ y: -8 }}
      className="group relative overflow-hidden rounded-[2rem] border border-white/10 bg-white/[0.055] p-7 backdrop-blur-xl transition-all duration-500 hover:border-pink-500/30 hover:bg-white/[0.09] hover:shadow-[0_25px_70px_rgba(236,72,153,0.12)]"
    >
      <div className="absolute -right-16 -top-16 h-40 w-40 rounded-full bg-pink-500/10 blur-3xl opacity-0 transition-opacity duration-500 group-hover:opacity-100" />

      <div className="absolute left-8 right-8 top-0 h-px bg-gradient-to-r from-transparent via-pink-500/60 to-transparent opacity-50 group-hover:opacity-100" />

      <div className="relative flex items-center justify-between">
        <div className="relative">
          <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-pink-500 to-violet-700 blur-lg opacity-30 group-hover:opacity-60 transition-opacity" />

          <motion.div
            whileHover={{ rotate: 6, scale: 1.08 }}
            className="relative grid h-14 w-14 place-items-center rounded-2xl bg-gradient-to-br from-pink-500 to-violet-700 shadow-lg"
          >
            <Icon className="h-7 w-7 text-white" />
          </motion.div>
        </div>

        <span className="font-mono text-xs font-bold tracking-widest text-slate-600 group-hover:text-pink-400/70 transition-colors">
          {number}
        </span>
      </div>

      <div className="relative mt-6">
        <span className="rounded-full border border-pink-400/10 bg-pink-400/5 px-3 py-1 text-[9px] font-bold uppercase tracking-[0.2em] text-pink-300">
          {tag}
        </span>
      </div>

      <div className="relative">
        <h3 className="mt-4 text-xl font-black tracking-tight text-white">
          {title}
        </h3>

        <p className="mt-3 min-h-[52px] text-sm leading-6 text-slate-400">
          {text}
        </p>
      </div>

      <div className="relative mt-7 flex items-center justify-between border-t border-white/10 pt-5">
        <span className="text-xs font-bold text-slate-400 transition-colors group-hover:text-pink-300">
          Explore service
        </span>

        <motion.div
          className="grid h-9 w-9 place-items-center rounded-full border border-white/10 bg-white/5"
          whileHover={{ scale: 1.1 }}
        >
          <ArrowUpRight className="h-4 w-4 text-slate-300 transition-colors group-hover:text-pink-400" />
        </motion.div>
      </div>
    </motion.div>
  );
}